// Function to check and remove extra widgets
function checkAndRemoveExtraWidgets() {
    const targetNode = document.querySelector('.route-div');
    if (targetNode) {
        const widgets = targetNode.querySelectorAll('route-protect-widget');
        if (widgets.length > 1) {
            widgets.forEach((widget, index) => {
                if (index < widgets.length - 1) {
                    widget.remove();
                }
            });
        }
    }
}

// Function to handle new children added to .route-div
function handleNewChildValidation() {
    const targetNode = document.querySelector('.route-div');
    if (targetNode) {
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    checkAndRemoveExtraWidgets();
                }
            }
        });
        // Start observing the target node for child additions
        observer.observe(targetNode, { childList: true });
    }
}

// Initialize the validation process on page load
window.addEventListener('DOMContentLoaded', () => {
    checkAndRemoveExtraWidgets(); // Initial check
    handleNewChildValidation(); // Setup observer for future changes
});